import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name,DEPENDENT_TABLES as depTableNames, CRUMB_LABEL_KEY,PARTS_AND_LABOURS } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
	},
	edit: {
		ServiceOrderHistoryId:null as number|null,
		OrderId:null as number |null,
		VehicleRegistrationNumber:null as string|null,
		VIN:null as string | null,
		RoNo:null as string|null,	
		CustomerID:null as string|null,
		CustomerName:null as string | null,
		CustomerVoice:null as string |null,
		ServiceOrderOpenDate: null as Date|null,
		ServiceOrderCloseDate:null as Date|null,
		SafetyRemarks:null as string |null,
		SellerDealerCode:null as string|null,
		ServiceDealerKvps:null as string|null,
		ServiceDealerName:null as string |null,
		NextServiceDate:null as Date|null,
		ServiceAdvisor:null as string |null,
		EntryKmRead:null as number|null,
		ExitKmRead:null as number|null,
		Amount:null as number|null,
		ModelCode:null as string|null,
		ModelName:null as string|null,
		ServiceAdvisorId:null as string|null,
		CarSaleDate:null as Date|null,
		BillToCustomer:null as string|null,
		InvoiceGenerateDate:null as Date|null,
		ServiceAdviserNo:null as string|null,
		OrderType:null as string|null,
		InvoiceNumber:null as string|null,
		ServiceRecommendation:null as string|null,
		VehicleArrivalDate:null as Date|null,
		EstimatedDeliveryDate: null as Date | null,
		EngineCode:null as string|null,
		OrderSubType:null as string|null,
	},
	depTableNames,
	depTableSettings: {
		[PARTS_AND_LABOURS]:{
			loadByEntityId: true,
			filter(state){
				return{
					ServiceOrderHistoryId:state.edit.ServiceOrderHistoryId,
					ServiceDealerKvps:state.edit.ServiceDealerKvps,
					OrderNo: state.edit.RoNo
				}
			}
		}
	},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
	},
});
